import { OrderLineViewModel } from '@models/api-orders.models';
import { removeEmpty } from '@utils/remove-empty.helper';
import { Product } from '@utils/gtm-tracking/model';

export const mapToOrderTrackableProduct = (line: OrderLineViewModel): Product => {
    const {
        productName,
        unitPriceRaw,
        variantNo,
        brand,
        quantity,
        discountAmountRaw,
        webCategoryL1Text,
        webCategoryL2Text,
        webCategoryL3Text,
        webCategoryL4Text,
        primaryColorText
    } = line;

    return removeEmpty({
        item_name: productName,
        item_id: variantNo,
        price: unitPriceRaw,
        item_brand: brand || '',
        quantity: quantity || 1,
        discount: discountAmountRaw || '',
        item_variant: primaryColorText || '',
        item_category: webCategoryL1Text || '',
        item_category_2: webCategoryL2Text,
        item_category_3: webCategoryL3Text,
        item_category_4: webCategoryL4Text
    }) as Product;
};
